import { useRentalUnitField } from '../../../../../../../../queries/useRentalUnitField';
import { NumberBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../../../../components/ApplicationQuestionReviewItem';
import { ShowIf } from '../../../../../../../components/ShowIf';

interface BedroomsProps {
    unitGuid: string;
    required: boolean;
    isReview?: boolean;
    showLabel?: boolean;
}

export const Bedrooms: React.FC<BedroomsProps> = ({ unitGuid, required, isReview = false, showLabel = false }) => {
    const label = 'Bedrooms';
    const [bedrooms, set_bedrooms] = useRentalUnitField(
        unitGuid,
        (u) => u.bedrooms,
        (u, v) => ({ ...u, bedrooms: v })
    );

    return (
        <>
            {isReview ? (
                <>
                    <ShowIf showIf={showLabel}>
                        <ApplicationQuestionReviewItem
                            label={label}
                            value={bedrooms}
                            showLabel={showLabel}
                        />
                    </ShowIf>
                    <ShowIf showIf={!showLabel}>{bedrooms}</ShowIf>
                </>
            ) : (
                <NumberBox
                    id={`bedrooms_${unitGuid}`}
                    value={bedrooms}
                    onChange={(value) => set_bedrooms(value)}
                    required={required}
                    label={showLabel ? label : undefined}
                />
            )}
        </>
    );
};
